import { render } from "./CopyText.vue?vue&type=template&id=d27e582c"
import script from "./CopyText.vue?vue&type=script&lang=ts"
export * from "./CopyText.vue?vue&type=script&lang=ts"
script.render = render

export default script